const $ = jQuery.noConflict();
function moveBannerDOM(){
 const section = $('.banner-section.fixed-section');
 section.insertAfter('.main-header');
}
export default moveBannerDOM;
